import React from 'react';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import Alert from '@jbhi-fi/lanyard-ui/components/Alert/Alert';
import { styles } from './TrackingResultHeader.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { MarkdownBlock } from '../../MarkdownBlock';
import { BaseContentSection, AlertProps } from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';
import { TimestampedAlert } from '../TimestampedAlert';

export type TrackingResultHeaderProps = {
  title?: string;
  subtitle?: string;
  disclaimer?: string;
  isOrderComplete?: boolean;
  status?: string;
  statusUpdatedAt: string;
  alert?: BaseContentSection & AlertProps;
  isTracked?: boolean;
};

const getHeaderAlert = (
  headerAlert: BaseContentSection & AlertProps,
  shipmentStatus: string,
  statusUpdatedAt: string
) => {
  if (shipmentStatus === 'Failed') {
    return <TimestampedAlert {...headerAlert} timestamp={statusUpdatedAt || ''} />;
  }
  return (
    <Alert
      {...headerAlert}
      content={<MarkdownBlock shouldLinkOpenInNewTab>{headerAlert.content || ''}</MarkdownBlock>}
      showIcon
    />
  );
};

export const TrackingResultHeader = ({
  title,
  subtitle,
  disclaimer,
  isOrderComplete,
  status,
  statusUpdatedAt,
  alert,
  isTracked,
}: TrackingResultHeaderProps) => {
  return (
    <div className={styles.container({ hasAlert: !!alert, isOrderComplete })} data-testid="order-tracking-result">
      <div className={styles.widthConstraint}>
        {title || subtitle ? (
          <div
            className={styles.titleAndSubtitleContainer({
              isOrderComplete: isOrderComplete,
            })}
          >
            {title ? <DomFont className={styles.title}>{title}</DomFont> : null}
            {subtitle ? (
              <span className={classNames(styles.subtitle, isOrderComplete ? styles.orderCompleteSubtitle : '')}>
                {subtitle}
              </span>
            ) : null}
            {disclaimer ? <span className={styles.disclaimer}>{disclaimer}</span> : null}
          </div>
        ) : null}
        {status && isTracked && status !== 'Failed' ? (
          <div className={styles.statusAndTime({ isOrderComplete: isOrderComplete })}>
            <span className={styles.status}>{status}</span>
            <span className={styles.lastUpdated}>{statusUpdatedAt}</span>
          </div>
        ) : null}
        {alert && alert.content ? (
          <div className={styles.alertContainer}>{getHeaderAlert(alert, status || '', statusUpdatedAt)}</div>
        ) : null}
      </div>
    </div>
  );
};
